import React from 'react';
import '../../src/App.css';
function Menu() {
  return (
    <section id='menu-body'>
      <h1>Menu</h1>
    </section>
  );
}

export default Menu;
